var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OfflineData } from '@tencent/ark-model';
/**
 * 转换老的 offline data model 为 ark-model 中的新 offline data model
 */
export function convertToArkOfflineData(offlineData) {
    return offlineData.map(function (data) {
        return new OfflineData(__assign(__assign({}, data), { data: data.data, subId: data.subSheetId, dataVersion: data.dver, type: data.type, docType: data.docType, docStatus: data.padStatus, createTimestamp: data.createTime, isDefaultChunk: data.default }));
    });
}
//# sourceMappingURL=DataConvert.js.map